import React, { useEffect, useState } from 'react';
import { TextField, Button, Switch, FormControlLabel, Box, Typography, Autocomplete } from '@mui/material';
import { PlusCircle, ArrowLeft, ChevronLeft, Gift } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../../components/Toast';
import { authApi } from '../../api/api';
import { User, Home, Shield, DollarSign, Heart } from 'react-feather';
import { set } from 'date-fns';

export default function AddBonus() {
    const [active, setActive] = useState(true);
    const [errors, setErrors] = useState({});
    const [assetName, setAssetName] = useState('');
    const [icon, setIcon] = useState(null);

    const [isLoading, setIsloading] = useState(false);

    const userNameOptions = [
        { label: "Real Estate", icon: <Home /> },
        { label: "Vehicles", icon: <User /> },
        { label: "Financial Accounts", icon: <DollarSign /> },
        { label: "Life Insurance", icon: <Shield /> },
        { label: "Personal Property", icon: <Heart /> },
         { label: "Others", icon: <Heart /> },
        // { label: "Other Assets", icon: <User /> }, // Replace with appropriate icon
      ];
    const token = useSelector((state) => state.auth.token);
    const userID = useSelector((state) => state.auth.id);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();
    const { assetId } = location.state || {};

    const handleActiveChange = (event) => {
        setActive(event.target.checked);
    };


    useEffect(() => {
        if (assetId) {
            viewAsset(assetId);
        }
    }, [assetId])


    const viewAsset = async (assetId) => {
        const input_token = `${assetId}VIEW_ASSET_TYPE`;
        const apiUrl = 'view_asset_type'; // Replace with the actual API endpoint
        const dataInput = {
            login_user_id: userID,
            id: assetId,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {

                setIcon({ label: data.asset_type_detail.asset_icon, icon: <User /> },)
                setAssetName(data.asset_type_detail.asset_type)
                setActive(!!data.asset_type_detail.status)

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    const validateForm = () => {
        const newErrors = {};

        if (!assetName.trim()) {
            newErrors.assetName = "Asset Name is required";
        }

        // if (!icon) {
        //     newErrors.icon = "Icon is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return;
        }


        const addBonusApi = async () => {
            setIsloading(true);
            const input_token = assetId + 'ASSET_TYPE_UPDATE';
            const apiUrl = 'update_asset_type';
            const formData = {
                id: assetId,
                auth_token: token, // Token from Redux state
                login_user_id: userID, // User ID from Redux state
                asset_type: assetName,
                asset_icon: icon.label,
                status: active ? 1 : 0,
            };
            try {
                const data = await authApi(input_token, formData, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false);
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false);
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false);    
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false);
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addBonusApi();

    };

    const RequiredLabel = ({ children }) => (
        <>
            {children} <span style={{ color: 'red' }}>*</span>
        </>
    );

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                <Box display="flex" alignItems="center">
                    <Gift style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Edit Asset
                    </Typography>
                </Box>

                <Button
                    variant="outlined"
                    component={Link}
                    to="/assetslist"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Assets list
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <form onSubmit={handleSubmit}>
                    <Box className="sub-header" sx={{ backgroundColor: '#f5f7ff', padding: '10px', borderRadius: '8px', marginBottom: '20px' }}>
                        <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                            <Link to="/bonus" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <ArrowLeft size={20} style={{ marginRight: '8px' }} />
                                Edit Asset
                            </Link>
                        </Typography>
                        <FormControlLabel
                            control={<Switch checked={active} onChange={handleActiveChange} />}
                            label={
                                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                    Active : {active ? 'Yes' : 'No'}
                                </Typography>
                            }
                        />
                    </Box>
                    <Grid container spacing={4} sx={{ mt: 2 }}>
                        <Grid size={4}>
                            <Typography><RequiredLabel>Asset Name</RequiredLabel></Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the asset name"
                                variant="outlined"
                                value={assetName}
                                onChange={(e) => setAssetName(e.target.value)}
                                error={!!errors.assetName}
                                helperText={errors.assetName}
                            />
                        </Grid>
                    </Grid>

                    <Grid item={12} sx={{ textAlign: 'center', marginTop: '30px' }}>
                        <Button
                            type="submit"
                            variant="contained"
                            startIcon={<PlusCircle size={20} />}
                            disabled={isLoading}
                             className='btn-theme-button'
                        >
                            Update Asset
                        </Button>
                    </Grid>

                </form>
            </Box>

        </Box>
    );
}
